import { ShopperHomePage } from "./../shopper-home/shopper-home";
// import { ShopperBuyProductPayScanPage } from "./../shopper-buy-product-pay-scan/shopper-buy-product-pay-scan";
import { ViewHeaderPage } from "./../view-header/view-header";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
} from "ionic-angular";
import { ShopperBuyProductPayInputPage } from "../shopper-buy-product-pay-input/shopper-buy-product-pay-input";

@IonicPage()
@Component({
  selector: "page-shopper-buy-product",
  templateUrl: "shopper-buy-product.html",
})
export class ShopperBuyProductPage {
  plaza_id: any;
  plaza = "";
  merchant_id = "";
  shops: any;
  shops2: any;
  shops3: any;
  shops4: any;
  shopSelect: any = [];
  shopSelectMerchant: any = [];
  url: any;
  budget: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController
  ) {
    this.plaza_id = this.navParams.data.plaza_id;
    // this.merchant_id = this.navParams.data.merchant_id;

    if (this.plaza_id == 1) {
      this.plaza = "A";
    } else if (this.plaza_id == 2) {
      this.plaza = "B";
    } else if (this.plaza_id == 3) {
      this.plaza = "C";
    } else if (this.plaza_id == 4) {
      this.plaza = "D";
    } else if (this.plaza_id == 5) {
      this.plaza = "E";
    } else if (this.plaza_id == 6) {
      this.plaza = "F";
    } else {
      this.plaza = this.plaza_id;
    }
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperShop + this.plaza_id + "/shops";

      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.shops = data.filter((x) => x.merchant.merchant_id == 1);
            this.shops2 = data.filter((x) => x.merchant.merchant_id == 2);
            this.shops3 = data.filter((x) => x.merchant.merchant_id == 3);
            this.shops4 = data.filter((x) => x.merchant.merchant_id == 4);
            loader.dismiss();
          },
          (error) => {
            loader.dismiss();
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      this.storage.get("info").then((info) => {
        if (info.role == 1) {
          this.url = this.services.URLPlazaStatBudgets;
        } else if (info.role == 2) {
          this.url = this.services.URLMerchantStatBudgets;
        } else if (info.role == 3) {
          this.url = this.services.URLShopperStatBudgets;
        }
        var link = this.url;

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.budget = this.services.currencyFormat(data.available);
            },
            (error) => {
              // console.log(error);
              this.services.presentToastInternet();
            }
          );
      });
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLShopperShop + this.plaza_id + "/shops";

      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.shops = data.filter((x) => x.merchant.merchant_id == 1);
            this.shops2 = data.filter((x) => x.merchant.merchant_id == 2);
            this.shops3 = data.filter((x) => x.merchant.merchant_id == 3);
            this.shops4 = data.filter((x) => x.merchant.merchant_id == 4);
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      this.storage.get("info").then((info) => {
        if (info.role == 1) {
          this.url = this.services.URLPlazaStatBudgets;
        } else if (info.role == 2) {
          this.url = this.services.URLMerchantStatBudgets;
        } else if (info.role == 3) {
          this.url = this.services.URLShopperStatBudgets;
        }
        var link = this.url;

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.budget = this.services.currencyFormat(data.available);
            },
            (error) => {
              // console.log(error);
              this.services.presentToastInternet();
            }
          );
      });
    });
    refresher.complete();
  }

  selectShop(shop_id, merchant_id) {
    var findArrMerchant = this.findDataMerchant(merchant_id);
    // console.log("findArrMerchant=",findArrMerchant);
    // console.log("shopSelectMerchant=",this.shopSelectMerchant);

    if (this.shopSelectMerchant.length > 0 && findArrMerchant == false) {
      const confirm = this.alertCtrl.create({
        // title: 'Do you want to change merchant?',
        message: "Do you want to change merchant?",
        buttons: [
          {
            text: "Yes",
            handler: () => {
              this.shopSelect = [];
              this.shopSelectMerchant = [];

              this.shopSelect.push(shop_id);
              this.shopSelectMerchant.push(merchant_id);
              this.merchant_id = merchant_id;
            },
          },
          {
            text: "No",
            cssClass: "btn-no",
            handler: () => {
              // console.log('Disagree clicked');
            },
          },
        ],
      });
      confirm.present();
    } else {
      var findArr = this.findData(shop_id, merchant_id);
      if (findArr) {
        this.removeArr(shop_id);
      } else {
        this.shopSelect.push(shop_id);
      }

      var findArrMer = this.findDataMerchant(merchant_id);
      if (findArrMer) {
        this.removeArrMerchant(merchant_id);
      } else {
        this.shopSelectMerchant.push(merchant_id);
        this.merchant_id = merchant_id;
      }

      this.shopSelectMerchant.push(merchant_id);
    }
  }

  findData(id, merchant_id) {
    var found = this.shopSelect.find(function (element) {
      return element == id;
    });
    // console.log("found=", found);
    if (found == id && this.merchant_id == merchant_id) {
      return true;
    } else {
      return false;
    }
  }

  findDataMerchant(id) {
    var found = this.shopSelectMerchant.find(function (element) {
      return element == id;
    });
    // console.log("found=", found);
    if (found == id) {
      return true;
    } else {
      return false;
    }
  }

  removeArr(id) {
    var indexID = this.shopSelect.indexOf(id);
    this.shopSelect.splice(indexID, 1);
    // console.log("data=", data);
    // console.log("shopSelect remove=", this.shopSelect);
    return true;
  }

  removeArrMerchant(id) {
    var indexID = this.shopSelectMerchant.indexOf(id);
    this.shopSelectMerchant.splice(indexID, 1);
    // console.log("data=", data);
    // console.log("shopSelect remove=", this.shopSelect);
    return true;
  }

  buy() {
    if (this.shopSelect.length > 0) {
      console.log(this.shopSelect);

      this.navCtrl.push(ShopperBuyProductPayInputPage, {
        plaza_id: this.plaza_id,
        merchant_id: this.merchant_id,
        items: this.shopSelect,
      });
    } else {
      this.translateService
        .get("Please select the shop you want to buy.")
        .subscribe((value) => {
          this.services.presentToast(value);
        });
    }
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-product/shopper-buy-product.ts